import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaList, FaPlus, FaSearch } from 'react-icons/fa';
import api from '../../../services/api';
import ReactSelect from '../../../components/ReactSelect';
import '../../../css/financeiro-parcela-pagar.css';

export default function PainelChecklistItens() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({ prazo: "2" });
    const [buscando, setBuscando] = useState(false);
    const [dados, setDados] = useState({});
    const [checklistItems, setChecklistItems] = useState([]);
    const params = new URLSearchParams(window.location.search);

    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const toggleSelect = id => setSelectedIds(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
    const toggleAll = () => paginados.length > 0 && selectedIds.size === paginados.length ? setSelectedIds(new Set()) : setSelectedIds(new Set(paginados.map(r => r.id)));
    const total = checklistItems.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = checklistItems.slice((page - 1) * pageSize, page * pageSize);
    const selectedArr = [...selectedIds];

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/eventoChecklist',
            token: token,
            params: {
                ...filtro,
                ...{
                    "naoMostrarModelos": true,
                    "situacao": 1
                },
            },
            signal: controllerRef.current.signal
        })
            .then(response => {
                setChecklistItems(response.data.data);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
            });
    };

    useEffect(() => {
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    const getEventoLabel = (row) => {
        if (row.nomeEvento) {
            if (row.identificacaoEvento) {
                return row.codigoEvento + ' - ' + row.identificacaoEvento + ' - ' + (row.nomeEvento ?? "");
            } else {
                return row.codigoEvento + ' - ' + (row.nomeEvento ?? "");
            }
        }
        return "";
    };

    const getClienteLabel = (row) => {
        if (row.nomeCliente) {
            if (row.nomeMunicipioCliente) {
                return row.codigoCliente + ' - ' + row.nomeCliente + ' - ' + row.nomeMunicipioCliente + ' - ' + row.ufMunicipioCliente;
            } else {
                return row.codigoCliente + ' - ' + row.nomeCliente;
            }
        }
        return "";
    };

    const getResponsavelLabel = (row) => {
        if (row.nomeResponsavel) {
            return row.codigoResponsavel + ' - ' + row.nomeResponsavel;
        }
        return "";
    };

    const getPrazoLabel = (row) => {
        if (row.distanciaEvento) {
            if (row.distanciaEvento < 0) {
                return <span style={{ color: "#e80d0d" }}>atraso de {row.distanciaEvento * -1} dias</span>;
            } else {
                return <span style={{ color: "#00AA00" }}>restam {row.distanciaEvento} dias</span>;
            }
        }
        return "";
    };

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Checklist</h1></div>
                    <div className="fin-pp__actions">
                        {['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'backoffice', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to="/cadastroEventoChecklist/" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"><FaPlus size={14} /> Novo Checklist</Link> :
                            null}
                        {['admin', 'diretor', 'gerenteprojeto'].includes(perfil) ?
                            <Link to="/eventoChecklistModelo" className="fin-pp__btn fin-pp__btn--pill" style={{ marginLeft: 8 }}><FaList size={14} /> Modelos de Checklist</Link> :
                            null}
                    </div>
                </div>

                <form className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }} onSubmit={e => { buscar(); e.preventDefault(); }}>
                    <div className="fin-pp__filters">
                        <div className="fin-pp__field">
                            <label className="fin-pp__label">Evento</label>
                            <ReactSelect
                                value={{ value: filtro.evento, label: filtro.nomeEvento }}
                                onChange={(e) => {
                                    setFiltro({ ...filtro, ...{ "evento": e.value, "nomeEvento": e.label } });
                                }}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/evento',
                                        token: token,
                                        params: {
                                            nome: input,
                                            situacao: ["ativo", "fechado", "cancelado"]
                                        }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map((registro) => {
                                                var label = registro.nome;
                                                if (registro.identificacao) {
                                                    label = registro.identificacao + " - " + label;
                                                }
                                                if (registro.cliente) {
                                                    label = label + ' - ' + registro.cliente.nome;
                                                }
                                                label = registro.codigo + " - " + label;
                                                return { value: registro.id, label: label };
                                            });
                                            return options;
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </div>
                        <div className="fin-pp__field">
                            <label className="fin-pp__label">Responsável</label>
                            <ReactSelect
                                value={{ value: filtro.responsavel, label: filtro.nomeResponsavel }}
                                onChange={e => setFiltro({ ...filtro, ...{ "responsavel": e.value, "nomeResponsavel": e.label } })}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/participante',
                                        token: token,
                                        params: {
                                            nome: input,
                                            tipoCadastro: ["pessoa"],
                                            situacaoRegistro: "ativo",
                                        }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map((registro) => {
                                                var label = registro.codigo +
                                                    ' - ' + registro.nome +
                                                    (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                    (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                    (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                    (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                return {
                                                    value: registro.id,
                                                    label: label
                                                };
                                            });
                                            return options;
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </div>
                        <div className="fin-pp__field">
                            <label className="fin-pp__label">Prazo (dias)</label>
                            <input
                                type="text"
                                className="fin-pp__input"
                                style={{ paddingLeft: 14 }}
                                placeholder="2 dias"
                                value={filtro.prazo ?? ''}
                                onChange={e => setFiltro({ ...filtro, ...{ "prazo": e.target.value } })}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                            <FaSearch size={14} /> {buscando ? 'Buscando...' : 'Buscar'}
                        </button>
                    </div>
                </form>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead><tr>
                                <th style={{ width: 40 }}><input type="checkbox" checked={paginados.length > 0 && selectedIds.size === paginados.length} onChange={toggleAll} /></th>
                                <th>Evento</th>
                                <th>Cliente</th>
                                <th>Responsável</th>
                                <th>Atividade</th>
                                <th>Prazo</th>
                            </tr></thead>
                            <tbody>
                                {buscando ? <tr><td colSpan={6} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                    : paginados.length === 0 ? <tr><td colSpan={6} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td><input type="checkbox" checked={selectedIds.has(row.id)} onChange={() => toggleSelect(row.id)} /></td>
                                                <td>{getEventoLabel(row)}</td>
                                                <td>{getClienteLabel(row)}</td>
                                                <td>{getResponsavelLabel(row)}</td>
                                                <td>{row.nomeAtividade ?? ""}</td>
                                                <td>{getPrazoLabel(row)}</td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select className="fin-pp__select" style={{ height: 34 }} value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                                <option value={15}>15 / pág</option><option value={30}>30 / pág</option><option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
